import {
  BANK_TAB,
  CUSTOMER_TAB,
  DISTRIBUTOR_TAB,
  DOCTORS_TAB,
  ENTITY_TAB,
  HEALTH_STATUS_TAB,
  HSN_TAB,
  PRODUCTS_TAB,
  TRANSPORTATION_TAB,
  ROLES_TAB,
  STOCK_AUDIT_TAB,
  USERS_TAB,
  REPORTS_STOCK_AUDIT,
  REPORTS_STOCK_TRANSFER,
  REPORTS_STOCK_REQUEST,
  REPORTS_MEDICINE_WISE_STOCK_AUDIT,
  PROFESSION_TAB,
  SPECIALITY_TAB,
  ADD_SYSTEM_TAB,
  REPORTS_MEDICINE_WISE_STOCK_TRANSFER,
  REPORTS_MEDICINE_WISE_STOCK_REQUEST,
  REPORTS_DISCOUNT_SLAB,
  REPORTS_DISCOUNT_PROGRAM,
  ADD_SERVICE_ITEM_TAB,
  MANUFACTURER_TAB,
  MANUFACTURER_GROUP_TAB,
  BRANCH_GROUP_TAB,
  RETAILER_REPORTS_TAB,
  REPORTS_FREQUENCY_SLAB_TAB,
  CAC_USER_TAB,
  CAC_ROLES_TAB,
} from "../../framework/tab/tabUtilsConstants";
import icons from "./../../assets/images/spotlight";
export const allMenus = [
  {
    main_menu: "roles_management",
    label: "Roles Management",
    menu_icon: icons.salesIcon,
    isAccessible: true,
    menu_icon_active: icons.salesActiveIcon,
    sub_menus: [
      {
        sub_menu: "Users",
        isAccessible: true,
        component: USERS_TAB,
        // menu_icon_active: icons.purchaseActiveIcon, //to overide main menu icon
      },
      {
        sub_menu: "Roles",
        isAccessible: true,
        component: ROLES_TAB,
        // menu_icon_active: icons.purchaseActiveIcon, //to overide main menu icon
      },
      {
        sub_menu: "Retailer",
        isAccessible: true,
        component: RETAILER_REPORTS_TAB,
      },
      {
        sub_menu: "CAC Users",
        isAccessible: true,
        component: CAC_USER_TAB,
      },
      {
        sub_menu: "CAC Users Roles",
        isAccessible: true,
        component: CAC_ROLES_TAB,
      },
    ],
  },
  {
    main_menu: "master",
    label: "Master",
    menu_icon: icons.salesIcon,
    isAccessible: true,
    menu_icon_active: icons.salesActiveIcon,
    sub_menus: [
      {
        sub_menu: "Products Master",
        isAccessible: true,
        component: PRODUCTS_TAB,
        // menu_icon_active: icons.purchaseActiveIcon, //to overide main menu icon
      },
      {
        sub_menu: "Doctor Master",
        isAccessible: true,
        component: DOCTORS_TAB,
        // menu_icon_active: icons.purchaseActiveIcon, //to overide main menu icon
      },
      {
        sub_menu: "Entity/Family Master",
        isAccessible: true,
        component: ENTITY_TAB,
      },
      {
        sub_menu: "Customer Master",
        isAccessible: true,
        component: CUSTOMER_TAB,
      },
      {
        sub_menu: "Bank Master",
        isAccessible: true,
        component: BANK_TAB,
      },
      {
        sub_menu: "HSN Master",
        isAccessible: true,
        component: HSN_TAB,
      },
      {
        sub_menu: "Distributor Master",
        isAccessible: true,
        component: DISTRIBUTOR_TAB,
      },
      {
        sub_menu: "Profession Master",
        isAccessible: true,
        component: PROFESSION_TAB,
      },
      {
        sub_menu: "Transport Master",
        isAccessible: true,
        component: TRANSPORTATION_TAB,
      },
      {
        sub_menu: "Service Item Master",
        isAccessible: true,
        component: ADD_SERVICE_ITEM_TAB,
      },
      {
        sub_menu: "Manufacturer Master",
        isAccessible: true,
        component: MANUFACTURER_TAB,
      },
      {
        sub_menu: "Manufacturer Group Master",
        isAccessible: true,
        component: MANUFACTURER_GROUP_TAB,
      },
      {
        sub_menu: "Branch Group Master",
        isAccessible: true,
        component: BRANCH_GROUP_TAB,
      },
      {
        sub_menu: "Speciality Master",
        isAccessible: true,
        component: SPECIALITY_TAB,
      },
    ],
  },
  {
    main_menu: "Miscellaneous",
    label: "Miscellaneous",
    menu_icon: icons.doctorIcon,
    isAccessible: true,
    menu_icon_active: icons.doctorActiveIcon,
    sub_menus: [
      {
        sub_menu: "Server Health",
        isAccessible: true,
        component: HEALTH_STATUS_TAB,
      },
      {
        sub_menu: "System",
        isAccessible: true,
        component: ADD_SYSTEM_TAB,
      },
    ],
  },
  {
    main_menu: "stockaudit",
    label: "Stock Audit",
    menu_icon: icons.salesIcon,
    isAccessible: true,
    menu_icon_active: icons.salesActiveIcon,
    sub_menus: [
      {
        sub_menu: "Stock Audit",
        isAccessible: true,
        component: STOCK_AUDIT_TAB,
        menu_icon_active: icons.reportsActiveIcon,
      },
      {
        sub_menu: "Stock Audit Report",
        isAccessible: true,
        component: REPORTS_STOCK_AUDIT,
        menu_icon_active: icons.reportsActiveIcon,
      },
    ],
  },
  {
    main_menu: "reports",
    label: "Reports",
    menu_icon: icons.reportsIcon,
    isAccessible: true,
    menu_icon_active: icons.reportsActiveIcon,
    sub_menus: [
      {
        sub_menu: "Stock Transfer Report",
        isAccessible: true,
        component: REPORTS_STOCK_TRANSFER,
        menu_icon_active: icons.reportsActiveIcon,
      },
      {
        sub_menu: "Stock Request Report",
        isAccessible: true,
        component: REPORTS_STOCK_REQUEST,
        menu_icon_active: icons.reportsActiveIcon,
      },
      {
        sub_menu: "Medicine Wise Stock Audit Report",
        isAccessible: true,
        component: REPORTS_MEDICINE_WISE_STOCK_AUDIT,
        menu_icon_active: icons.reportsActiveIcon,
      },
      {
        sub_menu: "Medicine Wise Stock Transfer Report",
        isAccessible: true,
        component: REPORTS_MEDICINE_WISE_STOCK_TRANSFER,
        menu_icon_active: icons.reportsActiveIcon,
      },
      {
        sub_menu: "Medicine Wise Stock Request Report",
        isAccessible: true,
        component: REPORTS_MEDICINE_WISE_STOCK_REQUEST,
        menu_icon_active: icons.reportsActiveIcon,
      },
      {
        sub_menu: "Discount Slab Report",
        isAccessible: true,
        component: REPORTS_DISCOUNT_SLAB,
        menu_icon_active: icons.reportsActiveIcon,
      },
      {
        sub_menu: "Discount Program Report",
        isAccessible: true,
        component: REPORTS_DISCOUNT_PROGRAM,
        menu_icon_active: icons.reportsActiveIcon,
      },
      {
        sub_menu: "Frequency Slab Report",
        isAccessible: true,
        component: REPORTS_FREQUENCY_SLAB_TAB,
        menu_icon_active: icons.reportsActiveIcon,
      },
    ],
  },
];
